











import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import AccordionItem from './AccordionItem.vue';

const AccordionProps = Vue.extend({
  props: {
    bgColor: {
      type: String,
      default: 'background-black',
      validator: (val) => ['background-white', 'background-black'].includes(val),
    },
    collapse: {
      type: Boolean,
      default: false,
    },
    spacing: {
      type: String,
      default: 'variant-no-spacing',
    },
  },
});

@Component
export default class Accordion extends mixins(AccordionProps, ParentComponentMixin, ResizeUpdateMixin) {
  items: ChildComponentCollection<AccordionItem> = new ChildComponentCollection<AccordionItem>();
  activeItem: AccordionItem | null = null;

  get rootClass () {
    return {
      'brandhub-accordion--spacing-above': this.spacing.includes('variant-spacing-above'),
      'brandhub-accordion--spacing-below': this.spacing.includes('variant-spacing-below'),
      'brandhub-accordion--background-black': this.bgColor === 'background-black',
      'brandhub-accordion--background-white': this.bgColor === 'background-white',
      'brandhub-accordion--no-spacing': this.spacing === 'variant-no-spacing',
    };
  }

  onAccordionItemClick (evt: CustomEvent) {
    if (this.collapse && this.activeItem !== evt.detail.clickedItem) {
      this.items.forEach((accordionItem) => {
        if (accordionItem === evt.detail.clickedItem) {
          accordionItem.open = true;
          this.activeItem = accordionItem;
        } else {
          accordionItem.open = false;
        }
      });
    }
  }

  created () {
    this.initParentComponentMixin(
      this.items,
      ['AccordionItem'],
    );
  }

  mounted () {
    this.$el.addEventListener('accordionItemClicked', this.onAccordionItemClick as EventListenerOrEventListenerObject);
  }
}

